import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FarmTypeList = Loadable(lazy(() => import("./FarmTypeList")));
const FarmTypeForm = Loadable(lazy(() => import("./FarmTypeForm")));

const farmTypeRoutes = [
  {
    path: "/FarmType/FarmTypeList",
    element: <FarmTypeList />,
  },
  {
    path: "/FarmType/FarmTypeForm",
    element: <FarmTypeForm />,
  },
  {
    path: "/FarmType/FarmTypeForm/:farmTypeId",
    element: <FarmTypeForm />,
  },
];
export default farmTypeRoutes;
